import Footer from "app/pages/.shared/Footer/Footer";

// @note la BASE_URL (envVars) présente dans "test" à savoir https://se2.test.perfectstay.io
// ne fonctionne pas. Il faut mettre https://se.test.perfectstay.io
export default props => <Footer {...props} />;
